import React, {useRef, useState} from  'react'
import './App.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore'; //database
import 'firebase/compat/auth';//user authentication
import 'firebase/compat/analytics';//google analytics

import {useAuthState} from 'react-firebase-hooks/auth'//for checking if a user is logged in
import {useCollectionData} from 'react-firebase-hooks/firestore'//for  the data that's being added to the database

firebase.initializeApp({
  //config files from firebase
  apiKey: "AIzaSyAUm99JBzjI7OvGh-0VGvbIeJNVrZX5Dbg",
  authDomain: "chat-app-1tawanda.firebaseapp.com",
  projectId: "chat-app-1tawanda",
  storageBucket: "chat-app-1tawanda.appspot.com",
  messagingSenderId: "926609025150",
  appId: "1:926609025150:web:0c7a7668f99a1c8748502f",
  measurementId: "G-LQD7F3TPQG"
});
const auth = firebase.auth();
const firestore = firebase.firestore();

function App() {

  const[user] = useAuthState(auth);

  return (
    <div className="App">
      <header className="App-header">
        <h1>Firebase Chat App</h1>
        <SignOut/>
      </header>

      <section className='App-section'>
          {user? <ChatRoom/> : <SignIn/>}
        </section>
    </div>
  );
}

function SignIn(){

  const signInWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    auth.signInWithPopup(provider);
  }


  return(
    <>
    <button className='sign-in' onClick = {signInWithGoogle}>Sign In With Google</button>
    <h4> Do not violate the community guidelines or else you will be banned for life</h4>
    </>
  )
}

 function SignOut(){
   return  auth.currentUser && (
     <button className='sign-out' onClick = {() => auth.signOut()}>Logout</button>
   )
 }

 function ChatRoom(){

  const dummy = useRef();
  const messagesRef = firestore.collection('messages');
  const query = messagesRef.orderBy('createdAt').limit(50);
  //listening to updates in realtime 
  const[messages] = useCollectionData(query, {idField: 'id'});

  const[formValue, setFormValue] = useState('');
 

 
  const sendMessage = async(e) => {
    e.preventDefault();

  const {uid, photoURL} = auth.currentUser;

  await messagesRef.add({
    text: formValue,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    uid,
    photoURL,
  })

  setFormValue("");
  dummy.current.scrollIntoView({ behavior: 'smooth'});
}
  
   return(
      <>
        <main>
          {messages && messages.map(msg => <ChatMessage   key={msg.id} message= {msg}/>)}
          <span ref = {dummy}></span>
          
        </main>
        <form onSubmit={sendMessage}>
          
          <input value={formValue} onChange = {(e) => setFormValue(e.target.value)} placeholder = "Say something"/>
          
          <button  type="submit" disabled={!formValue}>Send</button>
        </form>
      </>
   )
 }
 function ChatMessage(props){
   const {text, uid, photoURL} = props.message;
   const messageClass = uid === auth.currentUser.uid? 'sent': 'received';

     return(
      <> 
        <div className={`message ${messageClass}`}>
            <img src= {photoURL || 'https://api.adorable.io/avatars/23/abott@adorable.png'} alt=""/>
            <p>{text}</p>   
        </div>
     </>) 
 }
export default App;
